import { Typography, TypographyProps } from '@mui/material'
import React from 'react'
interface Props extends TypographyProps {}
const TimelineFormTitle: ReactFC<Props> = ({ children, sx, ...restParams }) => {
  return (
    <Typography
      sx={{
        fontWeight: 500, margin: '1rem 0 .5rem', ...sx
      }}
      {...restParams}
    >
      {children}
    </Typography>
  )
}
export default TimelineFormTitle
